import React, { useEffect, useState } from 'react'
import { Box, Heading, Text, Spinner, Button } from '@chakra-ui/react'
import { fetchWithoutAuth } from './apiClient'
import { useSearchParams, useNavigate } from 'react-router-dom'

export default function CompleteJob() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('t')
  const [status, setStatus] = useState(token ? 'loading' : 'missing') // loading | success | error | missing
  const [message, setMessage] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    if (!token) return
    async function doComplete() {
      try {
        const resp = await fetchWithoutAuth('/api/activity/complete-link', {
          method: 'POST',
          body: JSON.stringify({ 'token': token }),
        })
        if (resp.ok) {
          setStatus('success')
          setMessage('Task marked complete.')
        } else {
          setStatus('error')
          setMessage('This completion link is invalid or has already been used.')
        }
      } catch (err) {
        setStatus('error')
        setMessage('This completion link is invalid or has already been used.')
      }
    }
    doComplete()
  }, [token])

  return (
    <Box p={6} maxW="md" mx="auto">
      {status === 'loading' && (
        <Box textAlign="center">
          <Spinner />
          <Text mt={3}>Completing your task...</Text>
        </Box>
      )}

      {status === 'success' && (
        <Box>
          <Heading size="md">Completed</Heading>
          <Text>{message}</Text>
          <Button mt={4} onClick={() => navigate('/dashboard')}>
            Go to Dashboard
          </Button>
        </Box>
      )}

      {status === 'error' && (
        <Box>
          <Heading size="md">Unable to complete</Heading>
          <Text>{message}</Text>
          <Button mt={4} onClick={() => navigate('/login')}>
            Return to Login
          </Button>
        </Box>
      )}

      {status === 'missing' && (
        <Box>
          <Heading size="md">Completion link required</Heading>
          <Text>This page needs a completion link. Try the latest notification again.</Text>
          <Button mt={4} onClick={() => navigate('/login')}>
            Return to Login
          </Button>
        </Box>
      )}
    </Box>
  )
}
